/**
 * Bir korpusli bug'latgich — UnitModel.
 *
 * OGOHLANTIRISH KODLARI (i18n):
 *   evap.noEvaporation    critical  T_s ≤ T_b — harakatlantiruvchi kuch yo'q (params: Tsteam, Tb)
 *   evap.dryOut           critical  barcha erituvchi bug'landi
 *   evap.crystallization  warning   x_L > x_max (params: xL, xMax)
 *   evap.lowDeltaT        info      ΔT < 5 K
 */
import type { UnitModel } from '../../types';
import { initState, stepDynamic } from './dynamic';
import { solveSteady } from './steady';
import type { EvaporatorInputs, EvaporatorOutputs, EvaporatorParams, EvaporatorState } from './types';

export const evaporator: UnitModel<EvaporatorParams, EvaporatorInputs, EvaporatorState, EvaporatorOutputs, EvaporatorOutputs> = {
  id: 'evaporator',
  init: initState,
  step: stepDynamic,
  steady: solveSteady,
};

export * from './types';
export { instantBalance, boilingPoint, solutionCp, validateEvaporatorParams, validateEvaporatorInputs } from './steady';

